import * as angular from "angular";
import {IController} from "angular";

export class StopPurposeCtrl implements IController {
  stop: any;
  firstLetterOnly: string;
  stopsCount: any;

  public purpose: any;
  public text: string;


  /* @ngInject */
  constructor() {
  }

  $onInit() {
    if (this.stop) {
      this.setText();
    } else {
      this.purpose = undefined;
      this.text = undefined;
    }
  }

  $onChanges(onChangesObj: angular.IOnChangesObject) {
    if (onChangesObj.stop && !onChangesObj.stop.isFirstChange()) {
      if (this.stop) {
        this.setText();
      }
    }
  }

  ///////////////// Private Methods//////////
  private setText() {
    let text = '';
    const isStop = this.stop.type === 'STOP';
    const isGroup = this.stop.type === 'GROUP';
    this.purpose = (isStop || isGroup) ? this.stop.stopType : this.stop.type;

    text += (this.firstLetterOnly ? this.purpose.charAt(0) : this.purpose);

    if (isGroup) {
      text = (this.firstLetterOnly ? 'M' : 'Multi ') + text;
    }

    this.text = text;
  }

}

angular
  .module('bringoz.admin.planning')
  .component('stopPurpose', {
    bindings: {
      stop: '<',
      stopsCount: '<?',
      firstLetterOnly: '@'
    },
    template: require('./stop-purpose.html').default,
    controller: StopPurposeCtrl
  });
